import 'phaser';
import 'phaser/plugins/spine4.1/dist/SpinePlugin';
import BootScene from './scenes/bootScene';
import PreloadScene from './scenes/preloadScene';
import MainScene from './scenes/mainScene';
import '../assets/css/main.css';

export const gameSize = { width: 1920, height: 1080 };

export const appConfig = {
    antialiasGL: true,
    type: Phaser.WEBGL,
    width: 1920,
    height: 1080,
    // transparent: true,
    backgroundColor: 0x000000,
    input: {
        mouse: {
            preventDefaultWheel: true,
        },
    },
    scale: {
        parent: 'phaser-game',
        autoCenter: Phaser.Scale.CENTER_BOTH,
        mode: Phaser.Scale.FIT,
    },

    plugins: {
        global: [
            // {
            //     key: "rexBBCodeTextPlugin",
            //     plugin: BBCodeTextPlugin,
            //     start: true,
            // },
        ],
        scene: [{ key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' }],
    },
    scene: [BootScene, PreloadScene, MainScene],
};

window.addEventListener('load', () => {
    const game = new Phaser.Game(appConfig as any);
    globalThis.__PHASER_GAME__ = game;
});
